import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  nl: {
    translation: {
      "Where is Sam": "Where is Sam",
      "Weer": "Weer",
      "Blog": "Blog",
      "Home": "Home",
      "Foto's": "Foto's",
      "Profiel": "Profiel",
      "Profielfoto": "Profielfoto",
      "Profiel Opslaan": "Profiel Opslaan",
      "Uitloggen": "Uitloggen",
      "Wijzig": "Wijzig",
      "Voornaam": "Voornaam",
      "Achternaam": "Achternaam",
      "Login": "Login",
      "Register": "Registreren",
      "opvulling": "opvulling",
      "Weer en getijden": "Weer en getijden",
      "Live weer op vlieland. data van KNMI": "Live weer op Vlieland. Data van KNMI",
      "Bijgewerkt": "Bijgewerkt",
      "Data laden...": "Data laden...",
      "Laatste meting": "Laatste meting",
      "Temperatuur": "Temperatuur",
      "Wind": "Wind",
      "Windstoten": "Windstoten",
      "Golfhoogte": "Golfhoogte",
      "zicht": "Zicht",
      "Weerwaarschuwingen": "Weerwaarschuwingen",
      "Geen actieve waarschuwingen bekend.": "Geen actieve waarschuwingen bekend.",
      "Verwachting": "Verwachting",
      "Geen verwachting beschikbaar.": "Geen verwachting beschikbaar.",
      "5-daagse wind en golf verwachting": "5-daagse wind en golf verwachting",
      "Getijden": "Getijden",
      "Kies station": "Kies station",
      "Geen getijdedata beschikbaar voor deze locatie.": "Geen getijdedata beschikbaar voor deze locatie.",
      "Logboek": "Logboek",
      "Geen posts beschikbaar": "Geen posts beschikbaar",
      "Laatste albums": "Laatste albums",
      "Geen albums beschikbaar": "Geen albums beschikbaar",
      "Geen cover": "Geen cover",
      "Laden...": "Laden...",
      "Album niet gevonden": "Album niet gevonden",
      "← Terug": "← Terug",
      "Ook te zien bij:": "Ook te zien bij:",
      "Foto’s": "Foto’s",
      "Geen foto’s beschikbaar.": "Geen foto’s beschikbaar.",
      "Login of maak een account aan om een comment te plaatsen.": "Login of maak een account aan om een comment te plaatsen.",
      "Fout bij toevoegen comment": "Fout bij toevoegen comment",
      "Er is iets misgegaan.": "Er is iets misgegaan.",
      "Reacties": "Reacties",
      "De beste stuurlui staan aan wal": "De beste stuurlui staan aan wal",
      "reactie": "reactie",
      "reacties": "reacties",
      "Schrijf een reactie...": "Schrijf een reactie...",
      "Log eerst in om een reactie achter te laten.": "Log eerst in om een reactie achter te laten.",
      "Plaats reactie": "Plaats reactie",
      "Deel dit verhaal": "Deel dit verhaal",
      "Geen categorieën": "Geen categorieën",
      "onbekend": "onbekend",
      "onbekende": "onbekende",
      "Een woei van {{wind}} uit {{direction}} met een {{sea}} zee.": "Een woei van {{wind}} uit {{direction}} met een {{sea}} zee.",
      "Succesvol ingelogd!": "Succesvol ingelogd!",
      "Fout bij login": "Fout bij login",
      "Voer een geldig e-mailadres in.": "Voer een geldig e-mailadres in.",
      "Wachtwoord moet minimaal 6 tekens bevatten.": "Wachtwoord moet minimaal 6 tekens bevatten.",
      "Account aangemaakt! Je kunt nu inloggen.": "Account aangemaakt! Je kunt nu inloggen.",
      "Fout bij registreren": "Fout bij registreren",
      "Er is iets misgegaan, probeer het opnieuw.": "Er is iets misgegaan, probeer het opnieuw.",
      "Gebruikersnaam": "Gebruikersnaam",
      "Email": "Email",
      "Wachtwoord": "Wachtwoord",
      "Nog geen account?": "Nog geen account?",
      "Al een account?": "Al een account?",
      "Registreer": "Registreer",
      "Album niet gevonden.": "Album niet gevonden.",
      "Geen verwachting beschikbaar.": "Geen verwachting beschikbaar.",
      "Door": "Door",
      "Nog geen reacties. Wees de eerste!": "Nog geen reacties. Wees de eerste!",
      "Fout bij ophalen van albums.": "Fout bij ophalen van albums.",
      "Vessel Tracker": "Vessel Tracker",
      "Mijn reacties": "Mijn reacties",
      "Bewerk of verwijder je eigen comments.": "Bewerk of verwijder je eigen comments.",
      "Je hebt nog geen reacties geplaatst.": "Je hebt nog geen reacties geplaatst.",
      "Post": "Post",
      "Bekijk post": "Bekijk post",
      "Bewerken": "Bewerken",
      "Verwijderen": "Verwijderen",
      "Weet je zeker dat je deze reactie wilt verwijderen?": "Weet je zeker dat je deze reactie wilt verwijderen?",
      "Verwijderen mislukt.": "Verwijderen mislukt.",
      "Reactie bijgewerkt.": "Reactie bijgewerkt.",
      "Bijwerken mislukt.": "Bijwerken mislukt.",
      "Opslaan": "Opslaan",
      "Annuleren": "Annuleren",
      "Fout bij wijzigen wachtwoord.": "Fout bij wijzigen wachtwoord.",
      "Vorige foto": "Vorige foto",
      "Volgende foto": "Volgende foto",
      "Sluiten": "Sluiten",
      "Foto groot bekijken": "Foto groot bekijken",
      "Deze website gebruikt Google Analytics-cookies om verkeer te meten.": "Deze website gebruikt Google Analytics-cookies om verkeer te meten.",
      "Laad vessel tracker": "Laad vessel tracker",
      "Laad de tracker op aanvraag om mobiel sneller te houden.": "Laad de tracker op aanvraag om mobiel sneller te houden.",
      "Tracker wordt geladen zodra deze in beeld komt.": "Tracker wordt geladen zodra deze in beeld komt.",
    },
  },
  en: {
    translation: {
      "Where is Sam": "Where is Sam",
      "Weer": "Weather",
      "Blog": "Blog",
      "Home": "Home",
      "Foto's": "Photos",
      "Profiel": "Profile",
      "Profielfoto": "Profile picture",
      "Profiel Opslaan": "Save profile",
      "Uitloggen": "Log out",
      "Wijzig": "Change",
      "Voornaam": "First name",
      "Achternaam": "Last name",
      "Login": "Login",
      "Register": "Register",
      "opvulling": "placeholder",
      "Weer en getijden": "Weather and tides",
      "Live weer op vlieland. data van KNMI": "Live weather on Vlieland. Data from KNMI",
      "Bijgewerkt": "Updated",
      "Data laden...": "Loading data...",
      "Laatste meting": "Latest measurement",
      "Temperatuur": "Temperature",
      "Wind": "Wind",
      "Windstoten": "Wind gusts",
      "Golfhoogte": "Wave height",
      "zicht": "Visibility",
      "Weerwaarschuwingen": "Weather warnings",
      "Geen actieve waarschuwingen bekend.": "No active warnings.",
      "Verwachting": "Forecast",
      "Geen verwachting beschikbaar.": "No forecast available.",
      "5-daagse wind en golf verwachting": "5-day wind and wave forecast",
      "Getijden": "Tides",
      "Kies station": "Choose station",
      "Geen getijdedata beschikbaar voor deze locatie.": "No tide data for this location.",
      "Logboek": "Logbook",
      "Geen posts beschikbaar": "No posts available",
      "Laatste albums": "Latest albums",
      "Geen albums beschikbaar": "No albums available",
      "Geen cover": "No cover",
      "Laden...": "Loading...",
      "Album niet gevonden": "Album not found",
      "← Terug": "← Back",
      "Ook te zien bij:": "Also linked to:",
      "Foto’s": "Photos",
      "Geen foto’s beschikbaar.": "No photos available.",
      "Login of maak een account aan om een comment te plaatsen.": "Log in or create an account to post a comment.",
      "Fout bij toevoegen comment": "Error adding comment",
      "Er is iets misgegaan.": "Something went wrong.",
      "Reacties": "Comments",
      "De beste stuurlui staan aan wal": "Back-seat captains are plenty",
      "reactie": "comment",
      "reacties": "comments",
      "Schrijf een reactie...": "Write a comment...",
      "Log eerst in om een reactie achter te laten.": "Log in first to leave a comment.",
      "Plaats reactie": "Post comment",
      "Deel dit verhaal": "Share this story",
      "Geen categorieën": "No categories",
      "onbekend": "unknown",
      "onbekende": "unknown",
      "Een woei van {{wind}} uit {{direction}} met een {{sea}} zee.": "A breeze of {{wind}} from {{direction}} with a {{sea}} sea.",
      "Succesvol ingelogd!": "Logged in successfully!",
      "Fout bij login": "Login failed",
      "Voer een geldig e-mailadres in.": "Enter a valid email.",
      "Wachtwoord moet minimaal 6 tekens bevatten.": "Password must be at least 6 characters.",
      "Account aangemaakt! Je kunt nu inloggen.": "Account created! You can log in now.",
      "Fout bij registreren": "Registration failed",
      "Er is iets misgegaan, probeer het opnieuw.": "Something went wrong, try again.",
      "Gebruikersnaam": "Username",
      "Email": "Email",
      "Wachtwoord": "Password",
      "Nog geen account?": "Don't have an account?",
      "Al een account?": "Already have an account?",
      "Registreer": "Register",
      "Album niet gevonden.": "Album not found.",
      "Geen verwachting beschikbaar.": "No forecast available.",
      "Door": "By",
      "Nog geen reacties. Wees de eerste!": "No comments yet. Be the first!",
      "Fout bij ophalen van albums.": "Error fetching albums.",
      "Vessel Tracker": "Vessel Tracker",
      "Mijn reacties": "My comments",
      "Bewerk of verwijder je eigen comments.": "Edit or delete your own comments.",
      "Je hebt nog geen reacties geplaatst.": "You haven't posted any comments yet.",
      "Post": "Post",
      "Bekijk post": "View post",
      "Bewerken": "Edit",
      "Verwijderen": "Delete",
      "Weet je zeker dat je deze reactie wilt verwijderen?": "Are you sure you want to delete this comment?",
      "Verwijderen mislukt.": "Delete failed.",
      "Reactie bijgewerkt.": "Comment updated.",
      "Bijwerken mislukt.": "Update failed.",
      "Opslaan": "Save",
      "Annuleren": "Cancel",
      "Fout bij wijzigen wachtwoord.": "Error changing password.",
      "Vorige foto": "Previous photo",
      "Volgende foto": "Next photo",
      "Sluiten": "Close",
      "Foto groot bekijken": "View photo in large size",
      "Deze website gebruikt Google Analytics-cookies om verkeer te meten.": "This website uses Google Analytics cookies to measure traffic.",
      "Laad vessel tracker": "Load vessel tracker",
      "Laad de tracker op aanvraag om mobiel sneller te houden.": "Load the tracker on demand to keep mobile performance fast.",
      "Tracker wordt geladen zodra deze in beeld komt.": "The tracker loads when it enters the viewport.",
    },
  },
  de: {
    translation: {
      "Where is Sam": "Where is Sam",
      "Weer": "Wetter",
      "Blog": "Blog",
      "Home": "Home",
      "Foto's": "Fotos",
      "Profiel": "Profil",
      "Profielfoto": "Profilbild",
      "Profiel Opslaan": "Profil speichern",
      "Uitloggen": "Abmelden",
      "Wijzig": "Ändern",
      "Voornaam": "Vorname",
      "Achternaam": "Nachname",
      "Login": "Anmelden",
      "Register": "Registrieren",
      "opvulling": "Platzhalter",
      "Weer en getijden": "Wetter und Gezeiten",
      "Live weer op vlieland. data van KNMI": "Live-Wetter auf Vlieland. Daten von KNMI",
      "Bijgewerkt": "Aktualisiert",
      "Data laden...": "Daten laden...",
      "Laatste meting": "Letzte Messung",
      "Temperatuur": "Temperatur",
      "Wind": "Wind",
      "Windstoten": "Böen",
      "Golfhoogte": "Wellenhöhe",
      "zicht": "Sicht",
      "Weerwaarschuwingen": "Wetterwarnungen",
      "Geen actieve waarschuwingen bekend.": "Keine aktiven Warnungen.",
      "Verwachting": "Vorhersage",
      "Geen verwachting beschikbaar.": "Keine Vorhersage verfügbar.",
      "5-daagse wind en golf verwachting": "5-Tage Wind- und Wellenvorhersage",
      "Getijden": "Gezeiten",
      "Kies station": "Station wählen",
      "Geen getijdedata beschikbaar voor deze locatie.": "Keine Gezeitendaten für diesen Ort.",
      "Logboek": "Logbuch",
      "Geen posts beschikbaar": "Keine Beiträge verfügbar",
      "Laatste albums": "Neueste Alben",
      "Geen albums beschikbaar": "Keine Alben verfügbar",
      "Geen cover": "Kein Cover",
      "Laden...": "Laden...",
      "Album niet gevonden": "Album nicht gefunden",
      "← Terug": "← Zurück",
      "Ook te zien bij:": "Auch verlinkt bei:",
      "Foto’s": "Fotos",
      "Geen foto’s beschikbaar.": "Keine Fotos verfügbar.",
      "Login of maak een account aan om een comment te plaatsen.": "Melde dich an oder erstelle ein Konto, um zu kommentieren.",
      "Fout bij toevoegen comment": "Fehler beim Hinzufügen des Kommentars",
      "Er is iets misgegaan.": "Etwas ist schiefgelaufen.",
      "Reacties": "Kommentare",
      "De beste stuurlui staan aan wal": "Hinterher ist man schlau",
      "reactie": "Kommentar",
      "reacties": "Kommentare",
      "Schrijf een reactie...": "Schreibe einen Kommentar...",
      "Log eerst in om een reactie achter te laten.": "Melde dich zuerst an, um einen Kommentar zu hinterlassen.",
      "Plaats reactie": "Kommentar senden",
      "Deel dit verhaal": "Teile diese Geschichte",
      "Geen categorieën": "Keine Kategorien",
      "onbekend": "unbekannt",
      "onbekende": "unbekannt",
      "Een woei van {{wind}} uit {{direction}} met een {{sea}} zee.": "Ein Wind von {{wind}} aus {{direction}} mit einer {{sea}} See.",
      "Succesvol ingelogd!": "Erfolgreich eingeloggt!",
      "Fout bij login": "Fehler bei der Anmeldung",
      "Voer een geldig e-mailadres in.": "Gib eine gültige E-Mail-Adresse ein.",
      "Wachtwoord moet minimaal 6 tekens bevatten.": "Passwort muss mindestens 6 Zeichen haben.",
      "Account aangemaakt! Je kunt nu inloggen.": "Konto erstellt! Du kannst dich jetzt anmelden.",
      "Fout bij registreren": "Fehler bei der Registrierung",
      "Er is iets misgegaan, probeer het opnieuw.": "Etwas ist schiefgelaufen, versuche es erneut.",
      "Gebruikersnaam": "Benutzername",
      "Email": "E-Mail",
      "Wachtwoord": "Passwort",
      "Nog geen account?": "Noch kein Konto?",
      "Al een account?": "Schon ein Konto?",
      "Registreer": "Registrieren",
      "Album niet gevonden.": "Album nicht gefunden.",
      "Geen verwachting beschikbaar.": "Keine Vorhersage verfügbar.",
      "Door": "Von",
      "Nog geen reacties. Wees de eerste!": "Noch keine Kommentare. Sei der Erste!",
      "Fout bij ophalen van albums.": "Fehler beim Laden der Alben.",
      "Vessel Tracker": "Schiffs-Tracker",
      "Mijn reacties": "Meine Kommentare",
      "Bewerk of verwijder je eigen comments.": "Bearbeite oder lösche deine eigenen Kommentare.",
      "Je hebt nog geen reacties geplaatst.": "Du hast noch keine Kommentare geschrieben.",
      "Post": "Beitrag",
      "Bekijk post": "Beitrag ansehen",
      "Bewerken": "Bearbeiten",
      "Verwijderen": "Löschen",
      "Weet je zeker dat je deze reactie wilt verwijderen?": "Bist du sicher, dass du diesen Kommentar löschen willst?",
      "Verwijderen mislukt.": "Löschen fehlgeschlagen.",
      "Reactie bijgewerkt.": "Kommentar aktualisiert.",
      "Bijwerken mislukt.": "Aktualisierung fehlgeschlagen.",
      "Opslaan": "Speichern",
      "Annuleren": "Abbrechen",
      "Fout bij wijzigen wachtwoord.": "Fehler beim Ändern des Passworts.",
      "Vorige foto": "Vorheriges Foto",
      "Volgende foto": "Nächstes Foto",
      "Sluiten": "Schließen",
      "Foto groot bekijken": "Foto groß ansehen",
      "Deze website gebruikt Google Analytics-cookies om verkeer te meten.": "Diese Website verwendet Google-Analytics-Cookies, um den Verkehr zu messen.",
      "Laad vessel tracker": "Vessel-Tracker laden",
      "Laad de tracker op aanvraag om mobiel sneller te houden.": "Lade den Tracker bei Bedarf, um die mobile Leistung hoch zu halten.",
      "Tracker wordt geladen zodra deze in beeld komt.": "Der Tracker wird geladen, sobald er im Sichtbereich erscheint.",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "nl",
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
  });

export default i18n;
